import React, { useState } from 'react';
import { LockKeyholeIcon } from 'lucide-react';
import { Button } from '../sf/Button';
export function PinLockScreen({
  onUnlock
}: {
  onUnlock: () => void;
}) {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    if (!/^\d{4}$/.test(pin)) {
      setError('Enter your 4-digit PIN.');
      return;
    }
    setPin('');
    setError('');
    onUnlock();
  }
  return <section className="flex justify-center rounded border border-sf-border bg-white px-6 py-16 shadow-card" aria-labelledby="pin-title" data-id="element-955" data-mp="eb47nh2pisit">
      <form onSubmit={handleSubmit} className="w-full max-w-[320px] text-center" data-id="element-956" data-mp="t7d3s9rawpr0">
        <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-full bg-sf-blue-light" data-id="element-957" data-mp="o9tmt237xyvd">
          <LockKeyholeIcon className="h-5 w-5 text-sf-blue" aria-hidden="true" data-id="element-958" data-mp="2v01cuzqmm7ep" />
        </span>
        <h2 id="pin-title" className="mt-3 text-base font-bold" data-id="element-959" data-mp="2q1gihgy22hy6">
          Commission Dashboard is locked
        </h2>
        <p className="mt-1 text-xs text-sf-weak" data-id="element-960" data-mp="3f4rdek9ns0iw">Locked after inactivity (auto-lock timeout to be confirmed — open question). Enter your PIN to continue.</p>
        <label htmlFor="dashboard-pin" className="sr-only" data-id="element-961" data-mp="3o3csu6ju2zfg">
          4-digit PIN
        </label>
        <input id="dashboard-pin" type="password" inputMode="numeric" autoComplete="off" autoFocus maxLength={4} value={pin} onChange={event => setPin(event.target.value.replace(/\D/g, ''))} aria-invalid={Boolean(error)} className={`mt-4 h-10 w-full rounded border bg-white text-center text-lg tracking-[0.5em] focus:outline-none focus:ring-1 ${error ? 'border-sf-red focus:ring-sf-red' : 'border-sf-border-strong focus:border-sf-blue focus:ring-sf-blue'}`} data-id="element-962" data-mp="3sul314szmoto" />
        {error && <p className="mt-1 text-xs text-sf-red" data-id="element-963" data-mp="2hed0329n9bhh">{error}</p>}
        <Button type="submit" variant="brand" className="mt-3 w-full" data-id="element-964" data-mp="2hgzdhij7ul7m">
          Unlock
        </Button>
        <p className="mt-3 text-[11px] text-sf-weak" data-id="element-965" data-mp="3fqz1iqp5x2v0">Prototype: any 4 digits unlock.</p>
      </form>
    </section>;
}